'use client'

import React from 'react'
import Link from 'next/link'
import { CLIENT_PATHS } from '@/utilities/paths'

export function Footer() {
  return (
    <footer className="mt-auto text-dark-blue">
      <div className="container py-4 sm:py-6 px-3">
        <div className="flex flex-row flex-wrap items-center justify-center gap-x-2 gap-y-1">
          <div>
            <Link
              className="underline underline-offset-2 cursor-pointer text-bright-blue text-sm"
              href={CLIENT_PATHS.termsOfUse}
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Use
            </Link>
            <span className="text-dark-blue text-sm">,</span>
          </div>
          <div>
            <a
              className="underline underline-offset-2 cursor-pointer text-bright-blue text-sm"
              href="https://www.poweredbyash.com/privacy-policy"
              target="_blank"
              rel="noreferrer"
            >
              Privacy Policy
            </a>
            <span className="text-dark-blue text-sm">, and</span>
          </div>
          <div>
            <Link
              className="underline underline-offset-2 cursor-pointer text-bright-blue text-sm"
              href={CLIENT_PATHS.clientPortalConsent}
              target="_blank"
              rel="noopener noreferrer"
            >
              Portal Consent Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
